import React from "react";
import Dashboard from "../components/mentoring/Dashboard";

function Mentoring() {
    return (
      <>
        <Dashboard />
      </>
    );
  };
  
export default Mentoring;